// // src/pages/treatments/OncologyPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const ONCOLOGY_TREATMENT = {
//   slug: "oncology",
//   name: "Cancer Treatment",
//   shortName: "Oncology",
//   tagline: "Precision Care. Real Hope.",
//   heroSubtag:
//     "Advanced cancer care at a fraction of Western costs. Personalised oncology teams. Proven outcomes.",
//   description:
//     "Comprehensive cancer care combining surgery, chemotherapy, radiation, immunotherapy and targeted therapy under one roof. Our multidisciplinary tumour boards review every case to deliver globally benchmarked, personalised treatment plans.",
//   heroImage:"/PediatricOncology.jpeg",  
//   category: "Oncology",
//   badge: "Comprehensive Care",
//   accentColor: "purple",
//   costCard: {
//     label: "Cancer treatment packages",
//     value: "₹3L–₹12L",
//     compare: "vs. ₹45L+ in the UK",
//     stay: "Varies by treatment: 4 weeks to 6 months for full course",
//     stayCompare: "vs. $100,000+ in the US",
//   },
//   stats: [
//     { label: "Tumour Types", value: "50+", icon: Award },
//     { label: "Patients/Year", value: "10,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "Tumour Board Review", value: "Weekly", icon: Clock },
//   ],
//   benefits: [
//     "PET-CT, liquid biopsy & molecular profiling for precise diagnosis",
//     "Robotic & laparoscopic onco-surgery",
//     "Linear accelerator (LINAC) with IMRT/IGRT/SBRT capabilities",
//     "Targeted therapy & immunotherapy infusion centre",
//     "Dedicated bone marrow transplant unit",
//     "Survivorship and palliative care programmes",
//     "Clinical trial access for novel therapies",
//     "Psychological counselling & nutritional support",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Diagnosis & Staging",
//       desc: "Biopsy, molecular testing, PET-CT scan and tumour board review.",
//       duration: "5-7 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Treatment Planning",
//       desc: "Personalised protocol: surgery, chemo, radiation or combination.",
//       duration: "1 Week",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Active Treatment",
//       desc: "Surgery, chemotherapy cycles or radiation — as planned by the board.",
//       duration: "4-24 Weeks",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Survivorship & Monitoring",
//       desc: "Regular imaging, tumour markers and lifestyle support after remission.",
//       duration: "Ongoing",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What cancers do you treat?",
//       a: "We treat all major solid tumours (breast, lung, colon, prostate, cervical, liver, stomach) and blood cancers (leukaemia, lymphoma, myeloma), among 50+ tumour types.",
//     },
//     {
//       q: "What is a multidisciplinary tumour board?",
//       a: "A weekly meeting where surgeons, oncologists, radiologists, pathologists and support specialists jointly review each case to agree on the most effective personalised plan.",
//     },
//     {
//       q: "Is immunotherapy available?",
//       a: "Yes. We offer checkpoint inhibitors, CAR-T cell therapy and clinical trials for eligible patients across several cancer types.",
//     },
//     {
//       q: "How painful is chemotherapy?",
//       a: "Modern anti-nausea and supportive medications have greatly reduced side effects. Many patients continue working during treatment cycles.",
//     },
//     {
//       q: "Do you offer a second opinion?",
//       a: "Absolutely. You can upload reports for a digital second opinion from our senior oncologists within 48 hours.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Shyam Aggarwal",
//       specialty: "Medical Oncologist",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 2100,
//       image: "https://randomuser.me/api/portraits/men/33.jpg",
//       qualifications: "MBBS, MD, DM (Oncology), MRCP",
//       hospital: "Sir Ganga Ram Hospital, Delhi",
//     },
//     {
//       name: "Dr. Reena Nair",
//       specialty: "Surgical Oncologist",
//       experience: "20 Years",
//       rating: 4.9,
//       reviews: 1540,
//       image: "https://randomuser.me/api/portraits/women/41.jpg",
//       qualifications: "MBBS, MS (Surgery), MCh (Onco)",
//       hospital: "Tata Memorial Hospital, Mumbai",
//     },
//     {
//       name: "Dr. Anand Mishra",
//       specialty: "Radiation Oncologist",
//       experience: "18 Years",
//       rating: 4.8,
//       reviews: 980,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       qualifications: "MBBS, MD (Radiation Oncology)",
//       hospital: "Apollo Cancer Centre, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Meena Desai",
//       age: 44,
//       location: "Ahmedabad",
//       text: "Stage 3 breast cancer, and today I am in complete remission. The tumour board ensured I got the right combination of surgery and targeted therapy from day one.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/62.jpg",
//       treatment: "Breast Cancer – Surgery + Chemo",
//       date: "January 2024",
//     },
//     {
//       name: "Harish Bose",
//       age: 55,
//       location: "Kolkata",
//       text: "Colon cancer caught at stage 2 thanks to their early-detection programme. Robotic surgery, no colostomy bag, back home in 10 days. Truly life-changing.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/75.jpg",
//       treatment: "Colorectal Cancer – Robotic Surgery",
//       date: "March 2024",
//     },
//     {
//       name: "Preethi Rajan",
//       age: 38,
//       location: "Chennai",
//       text: "The counsellors and nutritionists made chemotherapy far more bearable than I feared. I never felt alone throughout my entire treatment journey.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/29.jpg",
//       treatment: "Ovarian Cancer – Chemo + Immunotherapy",
//       date: "April 2024",
//     },
//   ],
// };

// const ONCOLOGY_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African Patients Choose India",
//   whyIndiaReasons: [
//     "NABH-accredited oncology departments with PET-CT, Da Vinci robotic surgery, CyberKnife",
//     "Multidisciplinary tumour boards review every case within 48 hours of arrival",
//     "Treatment begins within 7 days — critical for aggressive cancers",
//     "Tata Memorial, AIIMS, Apollo, Fortis, Max — global oncology rankings",
//   ],
//   conditionsTitle: "Cancer Treatment Conditions We Facilitate",
//   conditions: [
//     "Breast Cancer",
//     "Lung Cancer",
//     "Prostate Cancer",
//     "Blood Cancers (Leukaemia, Lymphoma)",
//     "Colorectal Cancer",
//     "Cervical Cancer",
//     "Head & Neck Cancer",
//     "Paediatric Oncology"
//   ],
//   stayValue: "Varies by treatment: 4 weeks to 6 months for full course",
//   costTitle: "Why India for Cancer Treatment?",
//   costRows: [
//     {
//       procedure: "Chemotherapy (per cycle)",
//       india: "₹25,000–₹80,000",
//       africa: "$2,000–$6,000",
//       ukusa: "$10,000–$30,000",
//     },
//     {
//       procedure: "Radiation Therapy (full course)",
//       india: "₹2.5L–₹5L",
//       africa: "$25,000–$50,000",
//       ukusa: "$80,000–$150,000",
//     },
//     {
//       procedure: "Bone Marrow Transplant",
//       india: "₹12L–₹25L",
//       africa: "Largely unavailable",
//       ukusa: "$150,000–$300,000",
//     },
//   ],
// };

// const OncologyPage = () => {
//   return <TreatmentTemplate treatment={ONCOLOGY_TREATMENT} paxgrowData={ONCOLOGY_PAXGROW} />;
// };

// export default OncologyPage;

// src/pages/treatments/OncologyPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const ONCOLOGY_TREATMENT = {
  slug: "oncology",
  name: "Cancer Treatment",
  shortName: "Oncology",
  tagline: "Precision Care. Real Hope.",
  heroSubtag:
    "Advanced cancer care at a fraction of Western costs. Personalised oncology teams. Proven outcomes.",
  description:
    "Comprehensive cancer care combining surgery, chemotherapy, radiation, immunotherapy and targeted therapy under one roof. Our multidisciplinary tumour boards review every case to deliver globally benchmarked, personalised treatment plans.",
  heroImage: "/PediatricOncology.jpeg",
  category: "Oncology",
  badge: "Comprehensive Care",
  accentColor: "purple",
  costCard: {
    label: "Cancer treatment packages",
    value: "$3,600–$14,500",
    compare: "vs. $55,000+ in the UK",
    stay: "Varies by treatment: 4 weeks to 6 months for full course",
    stayCompare: "vs. $100,000+ in the US",
  },
  stats: [
    { label: "Tumour Types", value: "50+", icon: Award },
    { label: "Patients/Year", value: "10,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "Tumour Board Review", value: "Weekly", icon: Clock },
  ],
  benefits: [
    "PET-CT, liquid biopsy & molecular profiling for precise diagnosis",
    "Robotic & laparoscopic onco-surgery",
    "Linear accelerator (LINAC) with IMRT/IGRT/SBRT capabilities",
    "Targeted therapy & immunotherapy infusion centre",
    "Dedicated bone marrow transplant unit",
    "Survivorship and palliative care programmes",
    "Clinical trial access for novel therapies",
    "Psychological counselling & nutritional support",
  ],
  procedure: [
    {
      step: "01",
      title: "Diagnosis & Staging",
      desc: "Biopsy, molecular testing, PET-CT scan and tumour board review.",
      duration: "5-7 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Treatment Planning",
      desc: "Personalised protocol: surgery, chemo, radiation or combination.",
      duration: "1 Week",
      icon: Activity,
    },
    {
      step: "03",
      title: "Active Treatment",
      desc: "Surgery, chemotherapy cycles or radiation — as planned by the board.",
      duration: "4-24 Weeks",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Survivorship & Monitoring",
      desc: "Regular imaging, tumour markers and lifestyle support after remission.",
      duration: "Ongoing",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What cancers do you treat?",
      a: "We treat all major solid tumours (breast, lung, colon, prostate, cervical, liver, stomach) and blood cancers (leukaemia, lymphoma, myeloma), among 50+ tumour types.",
    },
    {
      q: "What is a multidisciplinary tumour board?",
      a: "A weekly meeting where surgeons, oncologists, radiologists, pathologists and support specialists jointly review each case to agree on the most effective personalised plan.",
    },
    {
      q: "Is immunotherapy available?",
      a: "Yes. We offer checkpoint inhibitors, CAR-T cell therapy and clinical trials for eligible patients across several cancer types.",
    },
    {
      q: "How painful is chemotherapy?",
      a: "Modern anti-nausea and supportive medications have greatly reduced side effects. Many patients continue working during treatment cycles.",
    },
    {
      q: "Do you offer a second opinion?",
      a: "Absolutely. You can upload reports for a digital second opinion from our senior oncologists within 48 hours.",
    },
  ],
  doctors: [
    {
      name: "Dr. Shyam Aggarwal",
      specialty: "Medical Oncologist",
      experience: "28 Years",
      rating: 4.9,
      reviews: 2100,
      image: "https://randomuser.me/api/portraits/men/33.jpg",
      qualifications: "MBBS, MD, DM (Oncology), MRCP",
      hospital: "Sir Ganga Ram Hospital, Delhi",
    },
    {
      name: "Dr. Reena Nair",
      specialty: "Surgical Oncologist",
      experience: "20 Years",
      rating: 4.9,
      reviews: 1540,
      image: "https://randomuser.me/api/portraits/women/41.jpg",
      qualifications: "MBBS, MS (Surgery), MCh (Onco)",
      hospital: "Tata Memorial Hospital, Mumbai",
    },
    {
      name: "Dr. Anand Mishra",
      specialty: "Radiation Oncologist",
      experience: "18 Years",
      rating: 4.8,
      reviews: 980,
      image: "https://randomuser.me/api/portraits/men/61.jpg",
      qualifications: "MBBS, MD (Radiation Oncology)",
      hospital: "Apollo Cancer Centre, Chennai",
    },
  ],
  testimonials: [
    {
      name: "Meena Desai",
      age: 44,
      location: "Ahmedabad",
      text: "Stage 3 breast cancer, and today I am in complete remission. The tumour board ensured I got the right combination of surgery and targeted therapy from day one.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/62.jpg",
      treatment: "Breast Cancer – Surgery + Chemo",
      date: "January 2024",
    },
    {
      name: "Harish Bose",
      age: 55,
      location: "Kolkata",
      text: "Colon cancer caught at stage 2 thanks to their early-detection programme. Robotic surgery, no colostomy bag, back home in 10 days. Truly life-changing.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/75.jpg",
      treatment: "Colorectal Cancer – Robotic Surgery",
      date: "March 2024",
    },
    {
      name: "Preethi Rajan",
      age: 38,
      location: "Chennai",
      text: "The counsellors and nutritionists made chemotherapy far more bearable than I feared. I never felt alone throughout my entire treatment journey.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/29.jpg",
      treatment: "Ovarian Cancer – Chemo + Immunotherapy",
      date: "April 2024",
    },
  ],
};

const ONCOLOGY_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African Patients Choose India",
  whyIndiaReasons: [
    "NABH-accredited oncology departments with PET-CT, Da Vinci robotic surgery, CyberKnife",
    "Multidisciplinary tumour boards review every case within 48 hours of arrival",
    "Treatment begins within 7 days — critical for aggressive cancers",
    "Tata Memorial, AIIMS, Apollo, Fortis, Max — global oncology rankings",
  ],
  conditionsTitle: "Cancer Treatment Conditions We Facilitate",
  conditions: [
    "Breast Cancer",
    "Lung Cancer",
    "Prostate Cancer",
    "Blood Cancers (Leukaemia, Lymphoma)",
    "Colorectal Cancer",
    "Cervical Cancer",
    "Head & Neck Cancer",
    "Paediatric Oncology",
  ],
  stayValue: "Varies by treatment: 4 weeks to 6 months for full course",
  costTitle: "Why India for Cancer Treatment?",
  costRows: [
    {
      procedure: "Chemotherapy (per cycle)",
      india: "$300–$1,000",
      africa: "$2,000–$6,000",
      ukusa: "$10,000–$30,000",
    },
    {
      procedure: "Radiation Therapy (full course)",
      india: "$3,000–$6,000",
      africa: "$25,000–$50,000",
      ukusa: "$80,000–$150,000",
    },
    {
      procedure: "Bone Marrow Transplant",
      india: "$14,500–$30,000",
      africa: "Largely unavailable",
      ukusa: "$150,000–$300,000",
    },
  ],
};

const OncologyPage = () => {
  return <TreatmentTemplate treatment={ONCOLOGY_TREATMENT} paxgrowData={ONCOLOGY_PAXGROW} />;
};

export default OncologyPage;